export default {
  label: {
    required: {
      notes: 'Text added to label of field when its required',
      message: '(required)',
    },
  },
  validation: {
    required: {
      notes: 'Error message for field when data is missing',
      message: '{{label}} is required',
      labelFallback: {
        notes:
          'Fallback label to show in validation text when field has no label',
        message: 'Field',
      },
    },
    minLength: {
      notes: 'Validation error message for minimum length for string',
      message: 'Minimum {{length}} characters required',
    },
    maxLength: {
      notes: 'Validation error message for miximum length for string',
      message: 'Maximum {{length}} characters allowed',
    },
    min: {
      notes: 'Validation error message for minimum value for numeric field',
      message: 'Minimum value is {{min}}',
    },
    max: {
      notes: 'Validation error message for maximum value for numeric field',
      message: 'Maximum value is {{max}}',
    },
    greaterThan: {
      notes:
        'Validation error message for greater than value for numeric field',
      message: 'Enter value greater than {{value}}',
    },
    lessThan: {
      notes: 'Validation error message for less than value for numeric field',
      message: 'Enter value less than {{value}}',
    },
    integer: {
      notes: 'Validation error message for integer value for numeric field',
      message: 'Enter a whole number',
    },
    decimal: {
      notes: 'Validation error message for decimal value for numeric field',
      message: 'Enter a decimal number',
    },
  },
};
